import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { ComponentWrapper } from "./ComponentWrapper";
import { MenuContent } from "../components";
import { usePersonalBeautyStore } from "../contexts";
import { SocialContactType, ReferralType } from "../models";
import { getContactByType, getLiveStreamingStateByVideoConfig, replacePlaceholdersInUrl } from "../utils";
import { jsx as _jsx } from "react/jsx-runtime";
export var MenuContentContainer = function MenuContentContainer(props) {
  var _pbsData$beautyStore, _pbsData$application$, _pbsData$application, _pbsData$application$2, _pbsData$application$3, _pbsData$application2, _productLists$;
  var _usePersonalBeautySto = usePersonalBeautyStore(),
    pbsData = _usePersonalBeautySto.pbsData,
    storeInfo = _usePersonalBeautySto.storeInfo;
  if (!(pbsData !== null && pbsData !== void 0 && (_pbsData$beautyStore = pbsData.beautyStore) !== null && _pbsData$beautyStore !== void 0 && _pbsData$beautyStore.profile) || (storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.type) === ReferralType.ECREF) {
    return null;
  }
  var _pbsData$beautyStore2 = pbsData.beautyStore,
    profile = _pbsData$beautyStore2.profile,
    productLists = _pbsData$beautyStore2.productLists,
    videoShows = _pbsData$beautyStore2.videoShows;
  var photoUrl = profile.photoUrl,
    contacts = profile.contacts,
    name = profile.name,
    referralProgram = profile.referralProgram;
  var _ref = referralProgram !== null && referralProgram !== void 0 ? referralProgram : {},
    allowedContacts = _ref.allowedContacts;
  var _ref2 = (_pbsData$application$ = (_pbsData$application = pbsData.application) === null || _pbsData$application === void 0 ? void 0 : (_pbsData$application$2 = _pbsData$application.videoShopping) === null || _pbsData$application$2 === void 0 ? void 0 : _pbsData$application$2.configuration) !== null && _pbsData$application$ !== void 0 ? _pbsData$application$ : {},
    isVideoShoppingEnabled = _ref2.isVideoShoppingEnabled,
    videoShoppingConfigurationAddThis = _ref2.addThis;
  var currentVideoShow = videoShows === null || videoShows === void 0 ? void 0 : videoShows.find(function (show) {
    return show === null || show === void 0 ? void 0 : show.isCurrent;
  });
  var _ref3 = videoShoppingConfigurationAddThis,
    videoShoppingUrl = _ref3.sharedUrl;
  var _ref4 = (_pbsData$application$3 = (_pbsData$application2 = pbsData.application) === null || _pbsData$application2 === void 0 ? void 0 : _pbsData$application2.personalProductListConfiguration) !== null && _pbsData$application$3 !== void 0 ? _pbsData$application$3 : {},
    pplConfigurationAddThis = _ref4.addThis,
    isPplEnabled = _ref4.isPplEnabled;
  var _ref5 = pplConfigurationAddThis,
    pplUrl = _ref5.sharedUrl;
  var userEmail = getContactByType(allowedContacts, contacts, SocialContactType.Email);
  var userPhone = getContactByType(allowedContacts, contacts, SocialContactType.PhoneNumber);
  return /*#__PURE__*/_jsx(ComponentWrapper, {
    children: /*#__PURE__*/_jsx(MenuContent, _objectSpread(_objectSpread({}, props), {}, {
      photoUrl: photoUrl,
      referralProgram: referralProgram,
      userEmail: userEmail,
      userPhone: userPhone,
      liveStreamingState: getLiveStreamingStateByVideoConfig({
        isVideoShoppingEnabled: isVideoShoppingEnabled,
        currentVideoShow: currentVideoShow
      }),
      videoShoppingConfiguration: {
        isEnabled: !!isVideoShoppingEnabled,
        sharedUrl: replacePlaceholdersInUrl(videoShoppingUrl, _objectSpread(_objectSpread({}, currentVideoShow ? {
          liveShowId: currentVideoShow.showId
        } : {}), name && {
          storeName: name
        }))
      },
      personalProductListConfiguration: {
        isEnabled: !!isPplEnabled,
        sharedUrl: replacePlaceholdersInUrl(pplUrl, _objectSpread({}, productLists && productLists.length >= 1 ? {
          personallist: (_productLists$ = productLists[0]) === null || _productLists$ === void 0 ? void 0 : _productLists$.productListId
        } : {}))
      }
    }))
  });
};